export const iconFontAwesomePhotosImagesBolt = (
	<i className="fa-solid fa-bolt"></i>
);
